import React from 'react';
import PropTypes from 'prop-types';
import { getIn } from 'seamless-immutable';
import { withDevice } from '@catalogo/core-connect/device';
import moduleList from '@catalogo/core-module-list/build/index.ui';

class SwitchComponent extends React.Component {
  render() {
    const { component, device } = this.props;
    const Component = getIn(moduleList, [device, component]);

    if (!Component) {
      return null;
    }

    return <Component {...this.props} />;
  }
}

SwitchComponent.propTypes = {
  component: PropTypes.string,
  device: PropTypes.string,
};

const SwitchComponentConnected = withDevice(SwitchComponent);

export { SwitchComponentConnected as SwitchComponent };
